import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';
import { createApp, h } from 'vue';
import '../css/app.css';
import { initializeTheme } from './composables/useAppearance';

import { pageTitle, siteNameFrom } from './lib/pageTitle';

// The commune's name, set in the site settings: read from the first page
// in setup(), before any title is rendered.
let siteName = import.meta.env.VITE_APP_NAME || 'Mairie';

createInertiaApp({
    title: (title) => pageTitle(title, siteName),
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.vue`,
            import.meta.glob<DefineComponent>('./pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        siteName = siteNameFrom(props.initialPage.props, siteName);

        const app = createApp({ render: () => h(App, props) });

        app.use(plugin).mount(el);

        // Error reporting only where a Sentry address is set (none by
        // default): without one, not a byte of it is built into the site,
        // and with one it loads after the first display.
        const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

        if (dsn) {
            void import('@sentry/vue').then((Sentry) => {
                Sentry.init({
                    app,
                    dsn,
                    environment:
                        (import.meta.env.VITE_APP_ENV as string) ??
                        'production',
                    integrations: [Sentry.browserTracingIntegration()],
                    tracesSampleRate: 0.2,
                });
            });
        }
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on page load...
initializeTheme();
